import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-O6-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 35.7 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-O6-logo_svg__cls-1{fill:red}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M21.58 31.26h3.68c1.53 0 2.21.13 2.63.32-.65-2.03-2.72-3.61-9.98-4.16 1.16 1.34 2.38 2.63 3.66 3.84ZM17.91 27.42C10.86 19.22 6.11 8.74 4.2 0 4.2 0 .33 3.42.02 10.61-.32 18.47 3.9 26.39 17.78 27.4c.04 0 .09 0 .13.01Z",
      class: "svg-O6-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M21.58 31.26H6.65c.2.46.88.79 2.44.88 9.32.55 10.63 7.86 23.97 7.86 1.17 0 1.9-.07 2.64-.21-5.27-1.62-10-4.67-14.12-8.54Z",
      class: "svg-O6-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "O6-logo"}) } }